<template>
    <div>
        <van-form @submit="onSubmit" :rules="formRules">

            <van-field v-model="attendanceDetail.teacherName" label="上课教师" placeholder="请选择上课教师" readonly/>
            <van-field v-model="attendanceDetail.courseName" label="课程" readonly/>

            <van-field v-model="attendanceDetail.startTime" label="上课开始时间" placeholder="请选择开始时间" readonly clickable
                @click="showStartTimePicker = true; startTimeDefault = attendanceDetail.startTime.split(':') || ['12', '00']" />
            <van-popup v-model:show="showStartTimePicker" position="bottom">
                <van-time-picker v-if="showStartTimePicker" v-model="startTimeDefault" @confirm="onStartTimeConfirm"
                    @cancel="showStartTimePicker = false" />
            </van-popup>

            <van-field v-model="attendanceDetail.endTime" label="上课结束时间" placeholder="请选择结束时间" readonly clickable
                @click="showEndTimePicker = true; endTimeDefault = attendanceDetail.endTime.split(':') || ['13', '00']" />
            <van-popup v-model:show="showEndTimePicker" position="bottom">
                <van-time-picker v-if="showEndTimePicker" v-model="endTimeDefault" @confirm="onEndTimeConfirm"
                    @cancel="showEndTimePicker = false" />
            </van-popup>

            <van-field label="是否跨校区">
                <template #input>
                    <van-switch v-model="attendanceDetail.isTransCampus" />
                </template>
            </van-field>

            <van-field v-model="attendanceDetail.overClassHour" label="加班课时" placeholder="请输入加班课时数" type="number" />

            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">
                    保存
                </van-button>
            </div>

            <!-- 加载遮罩 -->
            <van-overlay :show="loading">
                <div class="loading-wrapper">
                    <van-loading size="24px">提交中...</van-loading>
                </div>
            </van-overlay>
        </van-form>
    </div>
</template>


<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { showToast } from 'vant';
import { getAttendanceDetailByPlanIdForH5, updateAttendanceClassTime } from '@/api/schedule';

const route = useRoute();

const loading = ref(false);
const schedulePlanId = ref(null);
const courseId = ref(null);
const attendanceDetail = reactive({
    startTime: '',
    endTime: '',
    isTransCampus: false,
    overClassHour: 0
});
const showStartTimePicker = ref(false);
const showEndTimePicker = ref(false);
const startTimeDefault = ref(['12', '00']);
const endTimeDefault = ref(['13', '00']);

function getSchedulePlan() {
    getAttendanceDetailByPlanIdForH5(schedulePlanId.value).then(response => {
        Object.assign(attendanceDetail, response);
        attendanceDetail.classDate = attendanceDetail.startDateTime?.split(" ")[0] || '';

        if (response.startDateTime) {
            const startTime = response.startDateTime.split(" ")[1].slice(0, -3);
            attendanceDetail.startTime = startTime;
            startTimeDefault.value = startTime.split(':');
        } else {
            startTimeDefault.value = ['12', '00'];
        }

        if (response.endDateTime) {
            const endTime = response.endDateTime.split(" ")[1].slice(0, -3);
            attendanceDetail.endTime = endTime;
            endTimeDefault.value = endTime.split(':');
        } else {
            endTimeDefault.value = ['13', '00'];
        }

        attendanceDetail.isTransCampus = Boolean(response.isTransCampus || false);
        attendanceDetail.overClassHour = Number(response.overClassHour || 0);
    });
}

function onStartTimeConfirm(time) {
    attendanceDetail.startTime = `${time.selectedValues[0]}:${time.selectedValues[1]}`;
    showStartTimePicker.value = false;
}

function onEndTimeConfirm(time) {
    attendanceDetail.endTime = `${time.selectedValues[0]}:${time.selectedValues[1]}`;
    showEndTimePicker.value = false;
}

function convertTimeToMinutes(timeStr) {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + (minutes || 0);
}

function onSubmit() {
    const startTime = attendanceDetail.startTime;
    const endTime = attendanceDetail.endTime;

    const startMinutes = convertTimeToMinutes(startTime);
    const endMinutes = convertTimeToMinutes(endTime);

    if (endMinutes <= startMinutes) {
        showToast('上课结束时间必须大于开始时间');
        return;
    }

    loading.value = true;
    const param = {
        schedulePlanId: schedulePlanId.value,
        classTimes: [attendanceDetail.startTime, attendanceDetail.endTime],
        isTransCampus: attendanceDetail.isTransCampus ? 1 : 0,
        overClassHour: attendanceDetail.overClassHour,
    };

    updateAttendanceClassTime(param).then(() => {
        showToast('修改成功');
    }).catch(() => {
    }).finally(() => {
        loading.value = false;
    });
}

onMounted(() => {
    schedulePlanId.value = route.query.schedulePlanId;
    courseId.value = route.query.courseId;
    getSchedulePlan();
});
</script>

<style scoped>
/* 弹窗内容区域 */
.van-popup--bottom {
    background-color: #fff;
}

/* 搜索框样式 */
.van-search {
    padding: 10px 16px;
}

/* 列表项样式 */
.van-cell {
    border-bottom: 1px solid #ebedf0;
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>